function compareParameterGroups(a, b) {
  if (typeof a.order !== "undefined" && typeof b.order === "undefined") {
    return -1;
  }
  if (typeof a.order === "undefined" && typeof b.order !== "undefined") {
    return 1;
  }
  if (typeof a.order !== "undefined" && typeof b.order !== "undefined") {
    if (a.order > b.order) {
      return 1;
    }
    if (a.order < b.order) {
      return -1;
    }
  }
  return 0;
}
export {
  compareParameterGroups
};
//# sourceMappingURL=Parameters.utils.js.map
